<div class="my-scroll-container">
<mat-card class="processing-container">

    <mat-card-header class="headerFlex">
        <span class="forceFloatRight">
            <button mat-icon-button color="primary" (click)="closeRecord(false)">
                <span class="centercloseBtn"><mat-icon>close</mat-icon></span>
            </button>
        </span>
        <mat-card-title>
            Review Unresolved SSID
            <help-text-btn class="align-help-text-btn" [helpTextId]="'ResolvedUnMatchTasks'"></help-text-btn>
            <app-msg [msg]="msg" *ngIf="msg?.MSG"></app-msg>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <!-- processing overlay shown when an action is in progress -->
        <div *ngIf="isProcessing" class="processing-overlay">
            <div class="overlay-backdrop"></div>
            <div class="overlay-spinner">
                <mat-spinner diameter="48"></mat-spinner>
            </div>
        </div>
        <mat-divider></mat-divider>
        <br>
        <div class="row">
            <span class="header-no-space">Current MSIN Record</span>
        </div>

        <div *ngIf="isLoading">
            <mat-spinner></mat-spinner>
        </div>
        <div *ngIf="msg.SUCCESS && !this.isLoading" class="margin-top-md">
            <div class="row   table-responsive">
                <mat-table [dataSource]="tableDataSource" class="mat-elevation-z8">
                    <ng-container matColumnDef="MSD Number">
                        <mat-header-cell *matHeaderCellDef>
                            MSD Number
                        </mat-header-cell>

                        <mat-cell *matCellDef="let element">
                            <edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
                                [displayText]="this.msdNumber">
                            </edit-child-modal-btn>

                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef>
                            Name
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.PERSON.LAST_NAME |
                            titlecase}}{{(element.SECOND_LAST_NAME
                            ? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
                            {{element.PERSON.FIRST_NAME |
                            titlecase}}
                            {{element.PERSON.MIDDLE_INITIAL | titlecase}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="SSID">
                        <mat-header-cell *matHeaderCellDef>SSID</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.SSID}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="DOB">
                        <mat-header-cell *matHeaderCellDef>DOB</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.DOB | shortDateTime }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Gender">
                        <mat-header-cell *matHeaderCellDef>Gender</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.SEX }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Birth City">
                        <mat-header-cell *matHeaderCellDef>Birth City</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.BIRTH_CITY }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="CurrentSchoolDistrict">
                        <mat-header-cell *matHeaderCellDef>Current School District</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.SCHOOL_DISTRICT }} - {{element.COUNTY_CODE}}{{element.SCHOOL_DISTRICT_CODE}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Current Grade">
                        <mat-header-cell *matHeaderCellDef>Current Grade</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GRADE }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Guardian1">
                        <mat-header-cell *matHeaderCellDef>Parent/Guardian1</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GUARDIAN_NAME_1 }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Guardian2">
                        <mat-header-cell *matHeaderCellDef>Parent/Guardian2</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GUARDIAN_NAME_2 }}
                        </mat-cell>
                    </ng-container>


                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>

            </div>
        </div>



        <br>
        <br>
        <div class="row">
            <span class="header-no-space">CALPAD Potential Matches ({{ tableDataSourceSinf.data.length }})</span>
        </div>


        <div *ngIf="msg.SUCCESS && !this.isLoading" class="margin-top-md">
            <div class="row   table-responsive">
                <mat-table [dataSource]="tableDataSourceSinf" (matSortChange)="setupSorting($event)" matSort
                    #sinfTableSort="matSort" class="mat-elevation-z8">

                    <ng-container matColumnDef="Match">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <confirm-popover [type]="'submit'" [buttonTxt]="'Match'"
                                [popoverMsg]="getPopoverMsg(element)" [color]="'primary'"
                                (onConfirm)="selectMatch(element,'Match')">
                            </confirm-popover>

                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            Name
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{ displayNames(element) | titlecase }}<br>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="SSID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>SSID</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Ssid }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DOB">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>DOB</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.StudentBirthDate | shortDateTime }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Gender">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Gender</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.StudentGenderCode }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Birth City">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Birth City</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.StudentBirthCity }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="CurrentSchoolDistrict">
                        <mat-header-cell style="max-width: 250px;" *matHeaderCellDef mat-sort-header>Current School
                            District</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Senr?.ReportingLEA }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Current Grade">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Current Grade</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GradeLevelCode }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Guardian1">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Parent/Guardian1</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Guardian1FirstName }}
                            {{element.Guardian1LastName }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Guardian2">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Parent/Guardian2</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Guardian2FirstName }}
                            {{element.Guardian2LastName }}

                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumnsSinf"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsSinf;"></mat-row>
                </mat-table>


            </div>
        </div>

        <mat-paginator #sinfPaginator
            [disabled]="tableDataSourceSinf.data.length === 0 || tableDataSourceSinf.data.length <= 4"
            aria-label="Select page of potential matches" [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
        <br>
        <div style="padding-top: 30px"></div>
        <mat-divider></mat-divider>

        <mat-card-actions>

            <table class="table">
                <tr>
                    <td>
                        <confirm-popover [type]="'submit'" [buttonTxt]="'No Match'" [popoverMsg]="getPopoverMsg(null)"
                            (onCancel)="cancelMatch()" [color]="'warn'" (onConfirm)="selectMatch(null,'No Match')">
                        </confirm-popover>
                    </td>
                    <td>
                        <span class="bold"> Current SSID : </span> <span class="bold"> {{ this.CurrentSSID }}
                        </span>
                    </td>
                    <td>
                        <span class="bold"> Selected SSID : </span>
                        <div *ngIf="this.selectedSSID.length >0">
                            <span class="bold warning"> {{ this.selectedSSID }} </span>
                        </div>
                        <div *ngIf="this.selectedSSID.length ===0">
                            <span class="bold warning">No SSID selected (resolve as No Match) </span>
                        </div>
                    </td>
                </tr>
            </table>

        </mat-card-actions>
    </mat-card-content>
</mat-card>
</div>